export default "__VITE_ASSET__CSP7IOKl__"